export default __webpack_public_path__ + "static/media/MountainGlade.17f64c66.jpg";